"use client"

import Heading from "@/app/(site)/_components/Atoms/Heading"
import ButtonPill from "@/app/(site)/_components/Molecules/ButtonPill"
import { useLangCode } from "@/src/utils/locale/useLangCode"
import { t } from "@/translations"
import { useEffect } from "react"

type ErrorFallbackProps = {
    error: Error & { digest?: string }
    reset: () => void
}

export default function ErrorFallback({ error, reset }: ErrorFallbackProps) {
    const langCode = useLangCode()

    useEffect(() => {
        console.error(error)
    }, [error])

    return (
        <main className="flex flex-col items-center p-24 py-164 md:py-264">
            <Heading type="h1" className="mb-16 text-center md:mb-32">
                {t(langCode, "error.heading")}
            </Heading>
            <ButtonPill
                type="button"
                color="black"
                size="large"
                variant="primary"
                onClick={() => reset()}
            >
                {t(langCode, "common.retry")}
            </ButtonPill>
        </main>
    )
}
